import {DragDropContext, Draggable, DraggingStyle, Droppable, DropResult, NotDraggingStyle,} from "react-beautiful-dnd";
import {toast} from "react-toastify";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {deliveryState, setControlDeliveriesAction,} from "../../app/reducers/delivery-slice";
import {ControlDelivery} from "../../types/delivery/control-delivery";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import {ControlDeliveryCard} from "../card/ControlDeliveryCard";

type DraggableStyle = DraggingStyle | NotDraggingStyle | undefined;

export const DraggableControlDeliveriesItemList = () => {
    const dispatch = useAppDispatch();
    const {controlDeliveries} = useAppSelector(deliveryState);

    const reorder = (
        startIndex: number,
        endIndex: number,
        list: ControlDelivery[]
    ) => {
        {
            const splitIndex = list.findIndex(
                (controlDelivery) => controlDelivery.type === DeliveryGroupType.Split
            );

            if (splitIndex !== -1) {
                if (startIndex > endIndex && startIndex <= splitIndex) {
                    toast.error("진행중인 배송 이전으로 물류 순서를 변경할 수 없습니다.");
                    return list;
                }
            }

            if (list[startIndex].type === DeliveryGroupType.PickUp) {
                if (list[startIndex].delivery.pickUpDisabled) {
                    toast.error("완료된 물류는 순서를 변경할 수 없습니다.");
                    return list;
                }
            }

            if (list[endIndex].type === DeliveryGroupType.PickUp) {
                if (list[endIndex].delivery.pickUpDisabled) {
                    toast.error("완료된 물류는 순서를 변경할 수 없습니다.");
                    return list;
                }
            }

            if (list[startIndex].type === DeliveryGroupType.DropOff) {
                if (list[startIndex].delivery.dropOffDisabled) {
                    toast.error("완료된 물류는 순서를 변경할 수 없습니다.");
                    return list;
                }
            }

            if (list[endIndex].type === DeliveryGroupType.DropOff) {
                if (list[endIndex].delivery.dropOffDisabled) {
                    toast.error("완료된 물류는 순서를 변경할 수 없습니다.");
                    return list;
                }
            }

            const results = Array.from(list);
            const [removed] = results.splice(startIndex, 1);
            results.splice(endIndex, 0, removed);

            for (const controlDelivery of results) {
                const sameIdDeliveries = results.filter(
                    (result) => result.delivery.id === controlDelivery.delivery.id
                );
                if (sameIdDeliveries.length === 2) {
                    if (sameIdDeliveries[1].type === DeliveryGroupType.PickUp) {
                        toast.error("상차 물류는 전달 물류보다 먼저 배치할 수 없습니다.");
                        return list;
                    }
                }
            }

            return results;
        }
    };

    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        }

        const newControlDeliveries = reorder(
            result.source.index,
            result.destination.index,
            controlDeliveries
        );

        dispatch(
            setControlDeliveriesAction({
                deliveryKeys: newControlDeliveries.map(
                    (newControlDelivery) => newControlDelivery.key
                ),
            })
        );
    };

    const getItemStyle = (
        isDragging: boolean,
        draggableStyle: DraggableStyle
    ): React.CSSProperties => ({
        filter: `${
            isDragging
                ? "drop-shadow(0px 30px 30px rgba(0, 0, 0, 0.1))"
                : "drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.1))"
        }`,
        ...draggableStyle,
    });

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
                droppableId="deliveryGroup-card-draggable"
                direction="vertical"
            >
                {(provided, snapshot) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {controlDeliveries.map((controlDelivery, index) => (
                            <Draggable
                                key={controlDelivery.key}
                                draggableId={`control-delivery-draggable-${controlDelivery.key}`}
                                index={index}
                            >
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}
                                    >
                                        {controlDelivery.type !== DeliveryGroupType.Split && (
                                            <ControlDeliveryCard controlDelivery={controlDelivery}/>
                                        )}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
